/* ==========================================================================
   SMELLERS · Landing 4 — kit senior
   Un solo botón que arma el kit (2 Cazaorina + 1 neutralizador). Al ser 3
   unidades, el 30% automático de la tienda entra solo en el carrito.
   ========================================================================== */
(function () {
  'use strict';

  var page = document.querySelector('[data-sr-page]');
  if (!page) return;

  var busy = false;
  function root() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sr-add]');
    if (!btn) return;
    e.preventDefault();
    if (busy) return;

    /* formato "variantId:cantidad,variantId:cantidad" */
    var items = (btn.dataset.items || '')
      .split(',')
      .map(function (pair) {
        var p = pair.split(':');
        return { id: parseInt(p[0], 10), quantity: parseInt(p[1], 10) || 1 };
      })
      .filter(function (i) { return i.id; });

    if (!items.length) return;
    busy = true;
    btn.setAttribute('aria-busy', 'true');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status && data.status !== 200) throw new Error();
        window.location.href = root() + 'cart';
      })
      .catch(function () {
        busy = false;
        btn.removeAttribute('aria-busy');
        var err = document.querySelector('[data-sr-error]');
        if (err) {
          err.hidden = false;
          err.textContent = 'No pudimos armar tu kit. Intenta de nuevo o escríbenos por WhatsApp.';
        }
      });
  });

  /* ---------- barra sticky mobile ---------- */
  var dock = document.querySelector('[data-sr-dock]');
  var kit = document.getElementById('sr-kit');
  if (dock && 'IntersectionObserver' in window) {
    var pastHero = false;
    var kitVisible = false;

    function sync() {
      var show = pastHero && !kitVisible;
      dock.classList.toggle('is-up', show);
      page.classList.toggle('sr--dock-on', show);
    }

    var hero = document.querySelector('.sr__hero');
    if (hero) {
      new IntersectionObserver(function (en) {
        pastHero = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sync();
      }, { threshold: 0 }).observe(hero);
    }
    if (kit) {
      new IntersectionObserver(function (en) {
        kitVisible = en[0].isIntersecting;
        sync();
      }, { threshold: 0.12 }).observe(kit);
    }
  }
})();
